import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { UsuarioService } from '../../../services/usuario.service';
import { SidebarService } from '../../../services/sidebar.service';

@Component({
    selector: 'app-eco-layout-container',
    changeDetection: ChangeDetectionStrategy.OnPush,templateUrl: './eco-layout-container.component.html',
    styleUrls: ['./eco-layout-container.component.scss'],
    standalone: false
})
export class EcoLayoutContainerComponent implements OnInit, OnDestroy {

  timeLogout!: ReturnType<typeof setTimeout>;
  timePopup!: ReturnType<typeof setTimeout>;

  subscription!: Subscription;

  constructor(
    private usuarioService: UsuarioService, 
    public sidebarService: SidebarService 
  ) { }
  ngOnInit(): void {
    this.sidebarService.cargarMenu();
    this.closeSessionBy(600000);
  }

  ngOnDestroy(): void {
    this.resetTimers();
    this.subscription?.unsubscribe();
  }

  closeSessionBy(miliseconds: number): void {
    this.subscription = fromEvent(document, 'mousemove')
      .subscribe(_ => {
        this.resetTimers();
        this.timeLogout = setTimeout(() => {
          this.usuarioService.logout();
        }, miliseconds);
        this.timePopup = setTimeout(() => {
          this.triggerNotification();
        }, miliseconds - 30000);
      });
  }

  triggerNotification(): void {
    Swal.fire({
      position: 'top-end',
      icon: 'warning',
      text: 'Your session will be logged out',
      showConfirmButton: false,
      timer: 30000
    })
  }

  resetTimers(): void {
    Swal.close();
    clearTimeout(this.timeLogout);
    clearTimeout(this.timePopup);
  }

}
